import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

function AvailableBlockListPage() {
  const [basePlots, setBasePlots] = useState([]);
  const [availablePlots, setAvailablePlots] = useState([]); // 🔥 New state for available plots
  const [basePlotsLoading, setBasePlotsLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("project_id");
  const navigate = useNavigate();

  const getAuthToken = () => localStorage.getItem("token");

  const fetchBaseProjectPlots = async () => {
    if (!projectId) return;

    setBasePlotsLoading(true);

    try {
      const token = getAuthToken();
      const response = await fetch(
        `${API_URL}/plot-list-base-project?project_id=${projectId}&page=1&limit=1000`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();
      console.log("Base Project Plot API Response:", data);

      setBasePlots(data.data || []);

      // 🔥 Filter only available plots
      const available = (data.data || []).filter(
        (plot) => plot.status && plot.status.toLowerCase() === "available",
      );
      setAvailablePlots(available);
      console.log("Available plots found:", available.length);
    } catch (err) {
      console.error("Base project plot fetch error:", err);
      setBasePlots([]);
      setAvailablePlots([]);
    } finally {
      setBasePlotsLoading(false);
    }
  };

  useEffect(() => {
    fetchBaseProjectPlots();
  }, [projectId]);

  const handleBookPlot = (plot) => {
    const plotId = plot.id;
    navigate(
      `/plot-list?project_id=${plot.project_id}&block_id=null&plot_id=${plotId}`,
    );
  };

  if (basePlotsLoading) {
    return (
      <div className="padding_15 px-0">
        <div className="card">
          <div className="card-header">
            <div className="d-flex align-items-center justify-content-between">
              <div className="titlepage">
                <h3>Available Plots</h3>
              </div>
              <div className="backbutton">
                <Link to="/all-project">Back</Link>
              </div>
            </div>
          </div>
          <div className="card-body text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading available plots...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="padding_15 px-0">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center justify-content-between">
            <div className="titlepage">
              <h3>
                Available Plots
                <span className="badge bg-success ms-2">
                  {availablePlots.length} Available
                </span>
              </h3>
            </div>

            <div className="d-flex gap-2">
              <Link className="btn btn-primary submit_button border border-white"
                to={`/available-sold-plots-details?project_id=${projectId}`}
              >
                History
              </Link>
              <Link to="/available-Project" className="btn btn-success fw-bold">Back</Link>
            </div>
          </div>
        </div>

        <div className="card-body">
          {availablePlots.length > 0 ? (
            <div className="plot-chessboard">
              <div className="chessboard-grid">
                {availablePlots.map((plot) => (
                  <div
                    key={plot.id}
                    className="chess-cell cell-available"
                    onClick={() => handleBookPlot(plot)}
                  >
                    <div className="plot-number">
                      {(plot.plot_shop_villa_no || "N/A").toUpperCase()}
                    </div>

                    <div className="plot-status">
                      {plot.status || "available"}
                    </div>

                    {plot.area_sqyd && (
                      <div className="plot-area">{plot.area_sqyd} sqyd</div>
                    )}

                    {plot.rate && (
                      <div className="plot-rate">
                        ₹{Number(plot.rate).toLocaleString()}/sqyd
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-5">
              <div style={{ fontSize: "48px", marginBottom: "20px" }}>📊</div>
              <h4>No Available Plots</h4>
              <p className="text-muted">No available plots for this project.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AvailableBlockListPage;
